var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('ElCascader', {
    ref: function ref(e) {
      return _setup.selectDom = e;
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": [_setup.props.model.provinceCode, _setup.props.model.cityCode, _setup.props.model.areaCode],
      "options": _setup.data.opts,
      "props": {
        label: 'name',
        value: 'id'
      },
      "filterable": ""
    },
    on: {
      "change": _setup.changeArea
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };